import React, { ReactNode } from "react";
import cn from "classnames";
import s from "./ContentGridSlider.module.scss";
import c from "../../styles/container.module.scss";
import bs from "../../styles/block.spacing.module.scss";
import Item from "./components/Item";
import Navigation from "./components/Navigation";
import BlockIntro from "../Common/BlockIntro";
import {
  AlignmentVariant,
  InnerSpacingVariant,
} from "../../lib/storyblok/types/shared";
import type { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";

type Props = {
  title: string;
  description?: RichTextContent;
  buttons?: ReactNode;
  spacing?: InnerSpacingVariant;
  isStartpage?: boolean;
  children: ReactNode;
  contentAlignment: AlignmentVariant;
};

const subComponents = { Item, Navigation };
type SubComponents = typeof subComponents;

const ContentGridSlider: CWS<Props, SubComponents> = ({
  title,
  description,
  buttons,
  spacing = "both",
  children,
  contentAlignment = "alignLeft",
}) => {
  return (
    <section className={cn(s.section, bs[spacing])}>
      <div className={cn(c.xWide, s.intro)}>
        <BlockIntro
          alignment={contentAlignment}
          inverted={false}
          title={title}
          description={description}
          width={"contained"}
          buttons={buttons}
        />
      </div>
      <div className={cn(c.xWide, s.contentGrid)}>{children}</div>
    </section>
  );
};

ContentGridSlider.Item = Item;
ContentGridSlider.Navigation = Navigation;

export default ContentGridSlider;
